export const i18nScope = 'fa.notifications';

export const messages = {
  close: {
    defaultMessage: 'Close',
    id: 'fa.notifications.close-button',
  },
};
